// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

// TEMP: set REACT_APP_BYPASS_AUTH=false (or remove) to restore real login gate
export const isAuthBypassEnabled = () =>
    String(process.env.REACT_APP_BYPASS_AUTH || '').toLowerCase() === 'true';

const ProtectedRoute = ({ children }) => {
    if (isAuthBypassEnabled()) {
        return children;
    }

    const token = localStorage.getItem('kiosk_token');
    if (!token) {
        return <Navigate to="/" replace />;
    }
    return children;
};

export default ProtectedRoute;
